import type { TaskSubscriptionData } from '../schema/TaskSubscriptionData';

export type SubscriptionsCache<T> = { [subscriptionId: string]: TaskSubscriptionData<T> };

export function createSubscriptionCache<T>(): SubscriptionsCache<T> {
    return {};
}

export function addSubscription<T>(
    subscriptions: SubscriptionsCache<T>,
    subscriptionId: string,
    subscriptionData: TaskSubscriptionData<T>
) {
    if (!subscriptions[subscriptionId]) {
        subscriptions[subscriptionId] = subscriptionData;
    }
}

export function removeSubscription<T>(
    subscriptions: SubscriptionsCache<T>,
    subscriptionId: string
) {
    delete subscriptions[subscriptionId];
}

export function getSubscriptionsCount<T>(subscriptions: SubscriptionsCache<T>): number {
    return Object.keys(subscriptions).length;
}

export function notifySubscribers<T>(subscriptions: SubscriptionsCache<T>, callBackData: T) {
    // Get unique subscription callbacks by filtering out callbacks with the same callbackId
    const subscriptionDatas = Object.keys(subscriptions).map(key => subscriptions[key]);
    const uniqueSubscriptions: TaskSubscriptionData<T>[] = subscriptionDatas.reduce<
        TaskSubscriptionData<T>[]
    >(onlyUnique, []);
    uniqueSubscriptions.forEach(subscription => subscription.callback(callBackData));
}

function onlyUnique<T>(
    uniqueResult: TaskSubscriptionData<T>[],
    subscriptionData: TaskSubscriptionData<T>
) {
    if (!uniqueResult.some(item => item.callbackId === subscriptionData.callbackId)) {
        uniqueResult.push(subscriptionData);
    }
    return uniqueResult;
}
